import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface PersistentSessionState {
  doPersistAircraft: boolean
  aircrafts: string[]
}

const initialState: PersistentSessionState = {
  doPersistAircraft: false,
  aircrafts: [],
}

const persistentSessionSlice = createSlice({
  name: 'persistentSession',
  initialState,
  reducers: {
    setAircrafts: (state, action: PayloadAction<string[]>) => {
      state.aircrafts = action.payload
    },
    addAircraft: (state, action: PayloadAction<string>) => {
      if (state.aircrafts.includes(action.payload)) {
        return
      }
      state.aircrafts.push(action.payload)
    },
    removeAircraft: (state, action: PayloadAction<string>) => {
      state.aircrafts = state.aircrafts.filter(
        (aircraft) => aircraft !== action.payload
      )
    },
    resetAircrafts: (state) => {
      state.aircrafts = []
    },
    setDoPersistAircraft: (state, action: PayloadAction<boolean>) => {
      state.doPersistAircraft = action.payload
    },
  },
})

export const {
  setAircrafts,
  setDoPersistAircraft,
  resetAircrafts,
  addAircraft,
  removeAircraft,
} = persistentSessionSlice.actions

export default persistentSessionSlice.reducer
